export default {
  upload_common: {
    required: 'Diese Frage ist obligatorisch',
    max_length_500: 'Bitte antworten Sie innerhalb von 500 Wörtern.',
    please_enter_a_number: 'Zahlen eingeben',
    unexpected_error: 'Ein unerwarteter Fehler ist aufgetreten',
    temporarily_saved: 'Gespeicherte',
    unanswered_items: 'Es gibt unbeantwortete Fragen',
    answer_questionnaire_select: 'Wählen Sie eine Umfrage',
    entry: 'Bitte schreiben Sie Ihre Antwort.',
    target_select: 'Wählen',
    value_unit: 'Nummer',
    unit: 'Einheit',
    attach_documents: 'Dateien anhängen',
    textarea_placeholder: 'Bitte schreiben Sie Ihre Antwort bei Bedarf auf oder wenn Sie eine zusätzliche Erklärung hinzufügen möchten.',
    temporary_storage: 'Speichern',
    submit: 'Einreichen',
    last_saved_temporary: 'Zuletzt aktualisiert',
    There_are_unanswered_questions: 'Es gibt unbeantwortete Fragen',
    submitted_text: 'Diese Umfrage wurde bereits eingereicht.',
    submitted_at: 'Datum der Einreichung',
    withdrawal_of_answer: 'Einreichung zurückziehen',
    withdrawal_accepted: 'Rücknahme akzeptiert',
    help: 'Hilfe',
    example_of_evidence: 'Beispiel für einen Beweis',
    save_temporary_answer: 'Umfrage speichern',
    saved_temporary_answer: 'Ihre Antwort wurde gespeichert.',
    submit_answer: 'Umfrage einreichen',
    confirm_submit_answer: 'Sind Sie sicher, dass Sie die Umfrage abschicken möchten?',
    confirm_submit_shared_text: '\nIhre Antworten auf die Umfrage werden an Ihren Einkäufer weitergegeben.',
    complete_submit_answer: 'Die Umfrage wurde abgeschickt. \nWir danken Ihnen für Ihre Mitarbeit.',
    back_answer: 'Zurück',
    close: 'Schließen',
    save_temporary_answer_and_prev: 'Speichern und zurückgehen',
    save_temporary_answer_and_next: 'Speichern und weitergehen',
    prev: 'Zurück',
    next: 'Weiter',
    question_group_question_download: 'Umfrage Herunterladen',
    question_group_answer_download: 'Antworten herunterladen',
    question_group_download_answer_csv_title: 'Frage・Antwort(CSV)',
    question_group_download_answer_csv_description: 'Antworten im csv-Format herunterladen.',
    question_group_download_answer_pdf_title: 'Frage・Antwort(PDF)',
    question_group_download_answer_pdf_description: 'Antworten im pdf-Format herunterladen.',
    question_group_download_scorecard_pdf_title: 'Scorekarte(PDF)',
    question_group_download_scorecard_pdf_description: 'Punktestand im pdf-Format herunterladen.',
    question_group_download_esg_award_svg_title: 'ESG-Auszeichnung(SVG)',
    question_group_download_esg_award_svg_description: 'Auszeichnung im svg-Format herunterladen.',
    question_group_download_esg_award_pdf_title: 'ESG-Auszeichnung(PDF)',
    question_group_download_esg_award_pdf_description: 'Auszeichnung im pdf-Format herunterladen.',
    request_survey_withdrawal: 'Rücknahme der Umfrage anfordern',
    survey_withdrawal_description: 'Der Antrag auf Widerruf wird an Ihren Einkäufer gesendet.Bitte geben Sie unten den Grund an, warum Sie Ihre Umfrage zurückziehen möchten. \nDie Einzelheiten Ihres Antrags werden an Ihren Käufer weitergeleitet.',
    reason_withdrawal_request: 'Grund für den Rücknahmeantrag',
    completed_withdrawal_request: 'Ihr Antrag auf Rücknahme wurde angenommen. Bitte warten Sie, bis er genehmigt ist.',
    send: 'Senden',
    cancel: 'Abbrechen',
    balloon_title_withdrawal_request: 'Ihr Antrag auf Rücknahme wurde angenommen. ',
    no_survey: 'Es sind keine Bewertungsanfragen verfügbar.',
    failed_to_save_before_export: 'Temporäres Speichern vor dem Download fehlgeschlagen. Bitte überprüfen Sie, ob die eingegebenen Informationen korrekt sind',
    filter_unfilled_questions: 'Nur unbeantwortete Umfragen anzeigen',
    no_unfilled_questions: 'Es gibt keine unbeantworteten Fragen',
    move_page: 'Zur nächsten Seite gehen',
    confirm_move_page_message: 'Ihre Antworten werden nicht gespeichert. \nWenn Sie zu einer anderen Seite wechseln, gehen Ihre Antworten verloren.Möchten Sie Ihre Antworten speichern, bevor Sie weitergehen?',
    confirm_without_save: 'Nicht speichern',
    confirm_with_save: 'Speichern',
    error_save: 'Konnte vorübergehend nicht gespeichert werden. Bitte überprüfen Sie Ihre Antworten.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: 'Umfrage unter Bearbeitung',
    unable_edit_someone_editing_survey: 'Die Umfrage kann im Moment nicht bearbeitet werden, da sie gerade von einem Benutzer bearbeitet wird',
    user_editing_survey: 'wird gerade bearbeitet.',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'Vorherige Antworten',
      // overwrite_with_previous_answers: "",
      submitted_at: '(Eingereicht am {submitted_at})',
      // related_question: "",
      click_to_expand: 'Klicken Sie zum Erweitern',
      click_to_omit: 'Klicken Sie zum Auslassen',
      // description: "",
      answer_reference_function: 'Referenzfunktion beantworten',
      overwrite: 'Überschreiben',
      overwrite_confirm: 'Mit dieser Aktion werden frühere Antworten für Fragen, die in früheren Umfragen beantwortet wurden, eingefügt.\nFragen, die bereits beantwortet wurden, werden überschrieben.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Artikel',
      activity_amount: 'Betrag',
      emission_factor: 'Emissionsfaktor',
      emission_amount: 'Emissionen',
      unit_sale: 'Emissionsintensität',
      total: 'Gesamt',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/eine Million YEN',
    },
    label: {
      required_answer: 'Obligatorische Antwort',
      optional_answer: 'Optionale Antwort',
      conditional_required_answer: 'Verzweigung Obligatorische Antwort',
      note: 'Anmerkungen',
      // evidence_attachments: "",
    },
    // no_available_in_pdf: "",
    // comparison_question_meta: "",
    question_group_download_answered_csv_title: 'Frage・Antwort(CSV)',
    question_group_download_answered_pdf_title: 'Frage・Antwort(PDF)',
  },
}
